export default __webpack_public_path__ + "static/media/theFactorsPatti.6b740bf7.wav";